<Modal
  title="Are you sure?"
  actionTitle="DELETE"
  {isLoading}
  isDanger
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  <div class="block">
    <div class="notification is-danger is-light">
      WARNING: This action cannot be undone
    </div>
  </div>
  <p class="block">Your user account will be <span class="has-text-weight-bold">deleted</span>.</p>

  {#if errorMessage}
    <div class="block notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let userId :string, gotoPath :string = '.';

  import { goto } from "@sveltech/routify";
  import { uiState } from "../../../../lib/uiState";
  import Modal from "../../../_components/Modal.svelte"
  import { logging } from "../../../../lib/logging";

  let errorMessage :string;
  let isLoading :boolean;

  async function apply() {
    isLoading = true;

    let firebase = window.firebase;

    await firebase
      .functions()
      .httpsCallable("api-account-deleteUserSelf")({ id: userId, deactivateOrg: true } as DeleteUserParams)
      .then(() => {
        $uiState.activeModal = undefined;
        $goto(gotoPath);
      })
      .catch((err) => {
        errorMessage = err;
        logging.report(err.message);
      })
      .finally(() => (isLoading = false));
  }
</script>
